/**
 * This file is responsible for handling the service calls for the custom attributes
 */
import store from "../store";
import {
	callAPI,
	DEFAULT_LIST_PARAMS,
	GATEWAY_PROXY,
	METHODS,
} from "utils/apiUtils";

export function listCustomAttributesService(
	options = {
		listId: "",
		...DEFAULT_LIST_PARAMS,
		per_page: 500,
	},
	successCallback = () => {},
	failureCallback = () => {}
) {
	const { listId, ...restOptions } = options;
	if (!restOptions.per_page) restOptions.per_page = 500;
	callAPI(
		{
			url: GATEWAY_PROXY + `/lists/${listId}/custom-attributes`,
			method: METHODS.get,
			query: { ...restOptions, account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}

export function createCustomAttributesService(
	options = { listId: "", attribute: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + `/lists/${options.listId}/custom-attributes`,
			method: METHODS.post,
			body: options.attribute,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}

export function deleteCustomAttributesService(
	options = { listId: "", name: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url:
				GATEWAY_PROXY +
				`/lists/${options.listId}/custom-attributes/${options.name}`,
			method: METHODS.delete,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}
